import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import webservice from "../common/Webservice";
import {dispatchUpdateData} from "../misc/Shared";

const propTypes = {
	versionClient: PropTypes.object,
	versionWs: PropTypes.string,
};

const defaultProps = {
};

// Props connected to the store
const mapStateToProps = (state) => {
	return {
		versionClient: state.app.version.client,
		versionWs: state.app.version.ws,
	};
};

class Version extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
		if (!this.props.versionClient || this.props.versionWs === '') {
			webservice.public.version.getClient().then(data => {
				dispatchUpdateData([
					{path: 'app.version', field: 'client', value: data}
				]);
			});

			webservice.public.version.getWs().then(data => {
				dispatchUpdateData([
					{path: 'app.version', field: 'ws', value: data}
				]);
			});
		}
	}

	render() {
		return (
			<React.Fragment>
				<div>Client Version: {this.props.versionClient.version}</div>
				<div>WS Version: {this.props.versionWs}</div>
			</React.Fragment>
		);
	}
}

Version.propTypes = propTypes;
Version.defaultProps = defaultProps;

export default connect(mapStateToProps)(Version);